import * as AccordionPrimitive from '@radix-ui/react-accordion';
import React, { type ComponentPropsWithoutRef, type ReactNode } from 'react';
import { ChevronDownLarge } from '@/components/Icons/ChevronDownLarge';
import { tv } from '@/utils/tv';

const trigger = tv({
  base: 'group flex w-full cursor-pointer items-center justify-between gap-3 py-5 text-left text-body-16 text-foreground outline-none md:text-body-18',
});

const chevron = tv({
  base: 'size-6 shrink-0 text-muted-foreground transition-transform duration-200 group-data-[state=open]:rotate-180',
});

export const Accordion = AccordionPrimitive.Root;

interface AccordionItemProps extends ComponentPropsWithoutRef<
  typeof AccordionPrimitive.Item
> {
  className?: string;
}

export const AccordionItem: React.FC<AccordionItemProps> = ({
  className,
  ...props
}) => (
  <AccordionPrimitive.Item
    className={`border-b border-divider last:border-b-0 ${className ?? ''}`}
    {...props}
  />
);

interface AccordionTriggerProps {
  children: ReactNode;
  className?: string;
}

export const AccordionTrigger: React.FC<AccordionTriggerProps> = ({
  children,
  className,
}) => (
  <AccordionPrimitive.Header className="flex">
    <AccordionPrimitive.Trigger className={trigger({ className })}>
      {children}
      <ChevronDownLarge className={chevron()} />
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
);

interface AccordionContentProps {
  children: ReactNode;
  className?: string;
}

export const AccordionContent: React.FC<AccordionContentProps> = ({
  children,
  className,
}) => (
  <AccordionPrimitive.Content className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
    <div
      className={`pb-4 text-body-14 text-muted-foreground ${className ?? ''}`}
    >
      {children}
    </div>
  </AccordionPrimitive.Content>
);
